export type DevicePlatform = 'android' | 'desktop' | 'ios';

export const POLLS_APP_STORE_URL =
  'https://apps.apple.com/us/app/polls-by-the-information/id6814969991';

export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.theinformation.polls';
